import axiosInstance from "../../axiosInstance";
import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useEnv } from "../../context/EnvContext";

const RestartModal = ({
  showRestartModal,
  handleRestartClose,
  podInfo,
  cluster,
  onRestartSuccess,
}) => {
  const { env } = useEnv() || {};
  const handleRestartConfirm = async () => {
    // Handle missing data
    if (!env || !podInfo?.pod_name) {
      console.error("Missing required data for restarting pod");
      return;
    }

    console.log("Restarting pod:", podInfo.pod_name);
    // Call API to restart pod
    try {
      const response = await axiosInstance.post(
        `/restart-pod?cluster=${cluster}&namespace=238240-${env}&podName=${podInfo.pod_name}`
      );
      console.log("Pod restarted:", response.data);
      handleRestartClose();
      if (onRestartSuccess) {
        onRestartSuccess(); // Call the refresh function after successful restart
      }
    } catch (error) {
      console.error("Failed to restart pod:", error);
    }
  };

  return (
    <Modal
      show={showRestartModal}
      onHide={handleRestartClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title>Restart Pod</Modal.Title>
        <i
          className="fas fa-times"
          style={{ cursor: "pointer" }}
          onClick={handleRestartClose}
          title="Close"
        ></i>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to restart the pod?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleRestartClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleRestartConfirm}>
          Restart
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RestartModal;
